export const footerFallbackEn = {
  id: 1,
  locale: 'en',
  links: [
    {
      id: 8,
      title: 'RuStore',
      elements: [
        {
          id: 33,
          title: 'About RuStore',
          href: 'https://www.rustore.ru/help/en/users/about-rustore',
          isTargetBlank: true,
        },
        {
          id: 29,
          title: 'RuStore for TV',
          href: 'https://www.rustore.ru/tv',
          isTargetBlank: false,
        },
        {
          id: 28,
          title: 'RuStore for smartphones',
          href: 'https://www.rustore.ru/instruction',
          isTargetBlank: false,
        },
        {
          id: 31,
          title: 'Media kit',
          href: 'https://www.rustore.ru/media-kit',
          isTargetBlank: false,
        },
        {
          id: 30,
          title: 'Report a bug',
          href: 'https://bugbounty.standoff365.com/programs/rustore_vk',
          isTargetBlank: true,
        },
        {
          id: 32,
          title: 'Terms of use',
          href: 'https://www.rustore.ru/help/en/legal/terms-of-use',
          isTargetBlank: true,
        },
        {
          id: 35,
          title: 'Privacy policy (users)',
          href: 'https://www.rustore.ru/help/en/legal/privacy-policy-users',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 6,
      title: 'Help',
      elements: [
        {
          id: 34,
          title: 'Install RuStore on TV ',
          href: 'https://www.rustore.ru/help/en/users/start/install-on-tv/install-apk-on-tv',
          isTargetBlank: true,
        },
        {
          id: 36,
          title: 'Install RuStore on smartphone',
          href: 'https://www.rustore.ru/help/users/start/app-install',
          isTargetBlank: true,
        },
        {
          id: 37,
          title: 'Get started with RuStore',
          href: 'https://www.rustore.ru/help/en/users/start',
          isTargetBlank: true,
        },
        {
          id: 39,
          title: 'Purchases and returns',
          href: 'https://www.rustore.ru/help/en/users/purchases-and-returns',
          isTargetBlank: true,
        },
        {
          id: 38,
          title: 'Sign in to RuStore (SBER ID, VK ID)',
          href: 'https://www.rustore.ru/help/users/authorization',
          isTargetBlank: true,
        },
        {
          id: 41,
          title: 'Troubleshooting update issues ',
          href: 'https://www.rustore.ru/help/users/app-management/update-failure',
          isTargetBlank: true,
        },
        {
          id: 40,
          title: 'Parental control',
          href: 'https://help.rustore.ru/rustore/main_info/start/parental_control',
          isTargetBlank: true,
        },
        {
          id: 42,
          title: 'How to leave app review on RuStore ',
          href: 'https://www.rustore.ru/help/en/users/app-management/app-review',
          isTargetBlank: true,
        },
      ],
    },
    {
      id: 5,
      title: 'Developers',
      elements: [
        {
          id: 44,
          title: 'Enable monetization on RuStore',
          href: 'https://www.rustore.ru/help/en/developers/monetization',
          isTargetBlank: true,
        },
        {
          id: 43,
          title: 'Create developer account',
          href: 'https://www.rustore.ru/help/en/developers',
          isTargetBlank: true,
        },
        {
          id: 48,
          title: 'Open RuStore Console',
          href: 'https://dev.rustore.ru/en',
          isTargetBlank: false,
        },
        {
          id: 47,
          title: 'RuStore SDK Documentation',
          href: 'https://www.rustore.ru/help/en',
          isTargetBlank: true,
        },
        {
          id: 45,
          title: 'Create foreign company account ',
          href: 'https://www.rustore.ru/help/en/developers/developer-account/registration-developer/foreign-company-developer-account',
          isTargetBlank: true,
        },
        {
          id: 46,
          title: 'Software distribution agreement ',
          href: 'https://www.rustore.ru/help/en/legal/developers-agreement',
          isTargetBlank: true,
        },
        {
          id: 49,
          title: 'Privacy policy (developers) ',
          href: 'https://www.rustore.ru/help/en/legal/privacy-policy-developers',
          isTargetBlank: true,
        },
      ],
    },
  ],
  leftSideContent: {
    id: 2,
    copyright: '© VK 2022—2025 RuStore',
    qrCodeDescription:
      'Point your camera to download RuStore and follow the <a href="https://rustore.ru/instruction">instructions</a>',
    rustoreLogoHref: {
      id: 1532,
      name: 'logo_color_30 px.svg',
      width: 128,
      height: 32,
      url: 'https://static.rustore.ru/rustore-strapi/6/logo_color_30_px_57aa562dd4.svg',
    },
    qrCodeHref: {
      id: 712,
      name: 'qr-code.svg',
      width: 136,
      height: 136,
      url: 'https://static.rustore.ru/rustore-strapi/6/qr_code_340f0a7aed.svg',
    },
    webLandingSocialLinks: [
      {
        id: 6,
        href: 'https://vk.com/rustore_official',
        isTargetBlank: true,
        logoHref: {
          id: 1535,
          name: 'Iko_VK_28.svg',
          width: 28,
          height: 28,
          url: 'https://static.rustore.ru/rustore-strapi/6/Iko_VK_28_2368eb6a8b.svg',
        },
      },
      {
        id: 7,
        href: 'https://dzen.ru/rustore',
        isTargetBlank: true,
        logoHref: {
          id: 1534,
          name: 'Iko_dzen_28.svg',
          width: 28,
          height: 28,
          url: 'https://static.rustore.ru/rustore-strapi/6/Iko_dzen_28_9dacd5d21f.svg',
        },
      },
    ],
    devLandingSocialLinks: [
      {
        id: 8,
        href: 'https://vk.com/rustore_official',
        isTargetBlank: true,
        logoHref: {
          id: 1535,
          name: 'Iko_VK_28.svg',
          width: 28,
          height: 28,
          url: 'https://static.rustore.ru/rustore-strapi/6/Iko_VK_28_2368eb6a8b.svg',
        },
      },
      {
        id: 9,
        href: 'https://t.me/rustoredev',
        isTargetBlank: true,
        logoHref: {
          id: 2625,
          name: 'telegram.svg',
          width: 28,
          height: 28,
          url: 'https://static.rustore.ru/rustore-strapi/6/telegram_905e827f78.svg',
        },
      },
    ],
    webSocialLinks: [
      {
        id: 10,
        href: 'https://t.me/rustoredev',
        isTargetBlank: true,
        logoHref: {
          id: 2625,
          name: 'telegram.svg',
          width: 28,
          height: 28,
          url: 'https://static.rustore.ru/rustore-strapi/6/telegram_905e827f78.svg',
        },
      },
    ],
  },
};
